//primary types
export const TASK_ADD = 'TASK_ADD';
export const TASK_DONE = 'TASK_DONE';
export const TASK_ONGOING = 'TASK_ONGOING';
export const TASK_EDIT = 'TASK_EDIT';
export const TASK_DELETE = 'TASK_DELETE';
